import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SportsThemedSwitch } from '@frontend/sports/common/ui/sports-themed-switch';
import { DsSwitch } from '@frontend/ui/switch';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { EffectsModule } from '@ngrx/effects';

import { OddsPreferencePopupEffects } from './effects';
import { BetslipOddsActionComponent } from './odds-preference-popup.component';

@NgModule({
    imports: [CommonModule, EffectsModule.forFeature([OddsPreferencePopupEffects]), DsSwitch, IconCustomComponent, SportsThemedSwitch],
    exports: [BetslipOddsActionComponent],
    declarations: [BetslipOddsActionComponent],
})
export class BetslipOddsPreferencePopupModule {}
